module.exports = __webpack_public_path__ + "static/media/dark-green.7c80ac79.svg";